type _AxiosEnvConfig = {
  baseUrl: string;
};

const axiosEnvConfig: _AxiosEnvConfig = {
  baseUrl: process.env.REACT_APP_API_BASE_URL || "",
};

export { axiosEnvConfig };
